import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './BusinessResultModal.styles';
import { BusinessResultModalProps } from './BusinessPage.types';
import useScreenSize from '@/hooks/useScreenSize';
import { Popup } from '@/components/UI/Popup/Popup';
import { BottomSheet } from '@/components/UI/BottomSheet/BottomSheet';

export const BusinessResultModal: React.FC<BusinessResultModalProps> = ({
  showResultModal,
  onClose,
}) => {
  const { t } = useTranslation();
  const { isLarge } = useScreenSize();

  const modalContent = (
    <S.ModalContent data-testid="result-modal">
      <S.OuterCircle>
        <S.InnerCircle />
      </S.OuterCircle>
      {t('business.result.title')}
      <S.ModalDescription>
        {t('business.result.description')}
      </S.ModalDescription>
      <S.ModalCloseButton onClick={onClose}>
        {t('business.result.button')}
      </S.ModalCloseButton>
    </S.ModalContent>
  );

  return (
    <>
      {isLarge ? (
        <Popup
          isOpen={showResultModal}
          close={() => onClose}
          customSize={{ width: 'auto', height: 'auto' }}
        >
          {modalContent}
        </Popup>
      ) : (
        <BottomSheet isOpen={showResultModal} close={() => onClose}>
          {modalContent}
        </BottomSheet>
      )}
    </>
  );
};
